var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1343 3.68757L13.1345 3.6877L13.1423 3.67808C13.4161 3.34344 13.9161 3.2972 14.2774 3.59287C14.6208 3.87384 14.6456 4.36578 14.3749 4.66651L14.3748 4.66642L14.3681 4.6743L10.5005 9.20225L10.4046 9.31446V9.46204V19.4612C10.4046 19.9378 10.0278 20.2876 9.57828 20.2876C9.10168 20.2876 8.75196 19.9108 8.75196 19.4612V14.3201V13.9201H8.35196H6.60681H6.20681V14.3201V19.4612C6.20681 19.9108 5.85708 20.2876 5.38048 20.2876C4.90389 20.2876 4.55416 19.9108 4.55416 19.4612V9.46204V9.31446L4.45831 9.20225L0.593683 4.67781C0.30071 4.31668 0.347612 3.81874 0.681328 3.5457C1.0427 3.25004 1.54264 3.29628 1.81643 3.63091L1.81634 3.63099L1.82262 3.63829L4.69975 6.98708L4.69974 6.98709L4.70213 6.98981C5.10716 7.45271 5.64084 7.6924 6.22948 7.6924H8.72929C9.29377 7.6924 9.89145 7.46893 10.2662 6.97889L13.1343 3.68757Z",
    stroke: "#189FAA",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0273 3.23674C10.0273 4.63086 8.89718 5.76103 7.50304 5.76103C6.1089 5.76103 4.97874 4.63086 4.97874 3.23674C4.97874 1.84261 6.1089 0.712439 7.50304 0.712439C8.89718 0.712439 10.0273 1.84261 10.0273 3.23674Z",
    stroke: "#189FAA",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeIcon);
export default __webpack_public_path__ + "static/media/AgeIcon.afcfdab2a1b1adbe56d654820ecaeebe.svg";
export { ForwardRef as ReactComponent };